import { getFeatureAssetBaseUrl } from "./FeatureAssets";

export const getCustomFontUrl = (fontDataOrFile, campaignId) => {
    const fontFile = typeof fontDataOrFile === 'string' ? fontDataOrFile : fontDataOrFile?.fontFilename;
    const isTemplateFont = typeof fontDataOrFile === 'object'
        && fontDataOrFile?.assetSourceType === 'template'
        && fontDataOrFile?.assetSourceCampaignId;
    const resolvedCampaignId = isTemplateFont
        ? fontDataOrFile.assetSourceCampaignId
        : campaignId;
    const fontBaseUrl = getFeatureAssetBaseUrl() + `campaigns/${resolvedCampaignId ?? 'no-campaign'}/fonts/`;
    const fontUrl = fontBaseUrl + fontFile;
    console.log('[FONT URL]', { fontFile, isTemplateFont, resolvedCampaignId, fontUrl, inputData: fontDataOrFile });
    return fontUrl;
}

export const applyCampaignCustomFontsCss = (campaignData) => {
    if (!campaignData || !campaignData.customFonts || campaignData.customFonts.length === 0) return;
    
    for (let i = 0; i < campaignData.customFonts.length; i++) {
        const fontUrl = getCustomFontUrl(campaignData.customFonts[i], campaignData._id);
        const fontFamily = campaignData.customFonts[i].fontFamily;
        applyFontPreview(fontFamily, fontUrl, '.apply-custom-font-' + fontFamily.replace(/ /g, ''));
    }
}

export const applyFontPreview = (fontFamily, fontUrl, elementClass = '.apply-custom-font') => {
    // Create a font face style in the header if it doesn't already exist
    fontFamily = fontFamily.replace(/ /g, ''); // Replace spaces with nothing

    const styleId = 'custom-font-' + fontFamily + '-style';
    const existingStyle = document.getElementById(styleId);
    if (!existingStyle) {
        const customFontStyle = document.createElement('style');
        customFontStyle.id = styleId;
        customFontStyle.innerHTML = `
            @font-face {
                font-family: '${fontFamily}';
                src: url('${fontUrl}');
            }
        `;
        document.head.appendChild(customFontStyle);
    } else {
        // Ensure the font url is correct as it could have changed
        existingStyle.innerHTML = `
            @font-face {
                font-family: '${fontFamily}';
                src: url('${fontUrl}');
            }
        `;
    }

    // Create a style in the header for the custom font preview element, if it exists apply the updated font family, otherwise create it
    const elementStyleId = 'custom-font-preview-' + elementClass.substring(1) + '-style';
    const existingElementStyle = document.getElementById(elementStyleId);
    if (!existingElementStyle) {
        const customFontPreviewElementStyle = document.createElement('style');
        customFontPreviewElementStyle.id = elementStyleId;
        customFontPreviewElementStyle.innerHTML = `
            ${elementClass} {
                font-family: '${fontFamily}';
            }
        `;
        document.head.appendChild(customFontPreviewElementStyle);
    } else {
        existingElementStyle.innerHTML = `
            ${elementClass} {
                font-family: '${fontFamily}';
            }
        `;
    }
}

export const FontPreviewBlock = (props) => {
    return (
        <div className={`fl-column ${props.className ?? 'apply-font'}`} style={{ maxHeight: (props.maxHeight ?? '20rem'), overflowY: 'auto' }}>
            <h3>The quick brown fox jumps over the lazy dog.</h3>
            <h4>The quick brown fox jumps over the lazy dog.</h4>
            <h5>The quick brown fox jumps over the lazy dog.</h5>
            <p>The quick brown fox jumps over the lazy dog.</p>
        </div>
    )
}
